<template>
  <div style="background-color: #F4F7FE; min-height: 100vh;" class="pa-6">
    <v-row class="mb-6 px-4" align="center">
      <v-col cols="12" md="6">
        <h2 class="text-h4 font-weight-black" style="color: #1B2559;">Membresías</h2>
        <div class="d-flex align-center mt-1">
          <v-icon small color="#4318FF" class="mr-2">mdi-card-account-details-star</v-icon>
          <span class="text-subtitle-2 font-weight-bold" style="color: #A3AED0;">
            Configuración de planes y tarifas de LIVE FIT
          </span>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-md-end align-center">
        <v-text-field
          v-model="busqueda"
          append-icon="mdi-magnify"
          label="Buscar plan..."
          solo-inverted
          flat
          hide-details
          class="rounded-lg mr-4"
          style="max-width: 300px"
        ></v-text-field>
        <v-btn 
          color="#4318FF" 
          dark 
          class="rounded-lg elevation-1 text-none font-weight-bold"
          @click="mostrarDialogo = true"
        >
          <v-icon left>mdi-plus</v-icon> Nueva Membresía
        </v-btn>
      </v-col>
    </v-row>

    <v-card class="rounded-xl elevation-1 border-0 pa-4">
      <v-data-table
        :headers="encabezadoTabla"
        :items="membresias"
        :loading="cargando"
        :search="busqueda"
        sort-by="nombre"
        class="elevation-0"
        :footer-props="{itemsPerPageText: 'Filas por página'}"
      >
        <template v-slot:[`item.duracion`]="{ item }">
          <v-chip outlined small color="indigo" class="font-weight-bold">
            <v-icon left x-small>mdi-calendar-clock</v-icon>
            {{ item.duracion }} días
          </v-chip>
        </template>

        <template v-slot:[`item.precio`]="{ item }">
          <span class="text-h6 font-weight-black green--text text--darken-2">
            S/ {{ item.precio }}
          </span>
        </template>

        <template v-slot:[`item.opciones`]="{ item }">
          <div class="d-flex justify-center">
            <v-btn icon class="action-edit" @click="editar(item)">
              <v-icon small>mdi-pencil-outline</v-icon>
            </v-btn>
            <v-btn icon class="action-danger" @click="eliminar(item)">
              <v-icon small>mdi-trash-can-outline</v-icon>
            </v-btn>
          </div>
        </template>

        <template slot="no-data">
          <v-alert type="info" text class="ma-4 rounded-lg">
            No se han encontrado membresías registradas.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="mostrarDialogo" persistent max-width="600px">
      <form-membresia @cerrado="onCerrado" @registrar="onRegistrar" :membresia="membresia" :titulo="titulo"/>
    </v-dialog>

    <v-dialog v-model="mostrarDialogoEliminar" max-width="500px">
      <dialogo-eliminar :nombre="itemSeleccionado" @cancelar="cerrarDialogoEliminar" @eliminar="confirmarEliminar"/>
    </v-dialog>

    <v-overlay :value="cargando" color="#1B2559" opacity="0.8">
      <v-progress-circular indeterminate size="64" color="#4318FF" width="6"></v-progress-circular>
    </v-overlay>

    <v-snackbar v-model="mostrarMensaje" :timeout="3000" :color="mensaje.color" top rounded="pill">
      {{ mensaje.texto }}
    </v-snackbar>
  </div>
</template>

<script>
import FormMembresia from './FormMembresia.vue'
import DialogoEliminar from '../Dialogos/DialogoEliminar.vue'
import HttpService from '../../Servicios/HttpService'

export default ({
    name: "MembresiasEstandar",
    components: { FormMembresia, DialogoEliminar },
    data: () => ({
        busqueda: "",
        cargando: false,
        mostrarDialogo: false,
        mostrarDialogoEliminar: false,
        membresia: { nombre: "", duracion: "", precio: "" },
        membresias: [],
        mensaje: { texto: "", color: "" },
        mostrarMensaje: false,
        encabezadoTabla: [
            { text: "Membresía", value: "nombre", sortable: true },
            { text: "Duración", value: "duracion", sortable: true },
            { text: "Costo", value: "precio", sortable: true },
            { text: 'Acciones', value: 'opciones', sortable: false, align: 'center' },
        ],
        titulo: "Agregar",
        itemSeleccionado: ""
    }),
    mounted(){ this.obtenerMembresias() },
    methods:{
        obtenerMembresias(){
            this.cargando = true;
            HttpService.obtenerConDatos({metodo: "get"}, "membresias.php")
            .then(res => { this.membresias = res; this.cargando = false; })
        },
        editar(membresia){
            this.titulo = "Editar";
            this.membresia = Object.assign({}, membresia);
            this.mostrarDialogo = true;
        },
        eliminar(membresia){
            this.itemSeleccionado = membresia.nombre;
            this.membresia = membresia;
            this.mostrarDialogoEliminar = true;
        },
        confirmarEliminar() {
    this.cargando = true;
    HttpService.eliminar("membresias.php", { metodo: "delete", id: this.membresia.id })
    .then(res => {
       
        if(res && res.resultado === false) {
            this.mensaje = { 
                texto: res.mensaje, 
                color: "error" 
            };
            this.mostrarMensaje = true;
        } 
        else {
           
            this.mensaje = { texto: "Membresía eliminada", color: "success" };
            this.mostrarMensaje = true;
            this.obtenerMembresias();
        }
        this.mostrarDialogoEliminar = false;
        this.cargando = false;
    })
    .catch(() => {
        this.cargando = false;
        this.mensaje = { texto: "Error al conectar con el servidor", color: "error" };
        this.mostrarMensaje = true;
    });
},
        onRegistrar(membresia) {
            let metodo = (this.titulo === "Agregar") ? "post" : "put";
            this.cargando = true;
            HttpService.registrar({ metodo: metodo, membresia: membresia }, "membresias.php")
            .then(res => {
                if (res){
                    this.mostrarDialogo = false;
                    this.mensaje = { texto: "Operación realizada con éxito", color: "success" };
                    this.mostrarMensaje = true;
                    this.obtenerMembresias();
                }
                this.cargando = false;
            })
        },
        onCerrado(val) { this.mostrarDialogo = val; this.titulo = "Agregar"; },
        cerrarDialogoEliminar(){ this.mostrarDialogoEliminar = false; }
    }
})
</script>


// WEBPACK FOOTER //
// src/components/Membresias/Membresias.vue